// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"e15f51d3","38":"61f3d914","150":"e501b253","156":"9d4749f5","204":"6a609caf","954":"59744b03"}[chunkId] + ".chunk.js";
};